import { render, staticRenderFns } from "./goodsDelList.vue?vue&type=template&id=c23e7cc8&scoped=true&"
import script from "./goodsDelList.vue?vue&type=script&lang=js&"
export * from "./goodsDelList.vue?vue&type=script&lang=js&"
import style0 from "./goodsDelList.vue?vue&type=style&index=0&id=c23e7cc8&lang=less&scoped=true&"
import style1 from "./goodsDelList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23e7cc8",
  null
  
)

component.options.__file = "goodsDelList.vue"
export default component.exports